import { CONTACT_EMAIL } from "@/lib/legal/seller";
import { toWhatsAppLink } from "@/lib/whatsapp-link";

/**
 * Single source of truth for Dr. Sara's public profiles.
 *
 * ⚠️ NEVER link a @drsaranahas handle (instagram/facebook/x). That is a
 * different public figure (Dr. Sara El Nahas) who happens to share our
 * domain name. Our handles are @dr.saraalnahas / DrSaraAlnahhas.
 */
export const SOCIAL = {
  instagram: "https://www.instagram.com/dr.saraalnahas",
  tiktok: "https://www.tiktok.com/@dr.saraalnahas",
  youtube: "https://www.youtube.com/@dr.saraalnahas1",
  facebook: "https://www.facebook.com/DrSaraAlnahhas",
  threads: "https://www.threads.com/@dr.saraalnahas",
} as const;

export const INSTAGRAM_HANDLE = "@dr.saraalnahas";

/** The five profile URLs, for schema.org `sameAs`. */
export const SOCIAL_SAME_AS: string[] = [
  SOCIAL.instagram,
  SOCIAL.tiktok,
  SOCIAL.youtube,
  SOCIAL.facebook,
  SOCIAL.threads,
];

export const SOCIAL_EMAIL = CONTACT_EMAIL;

/** site_settings.instagram_url overrides the default when set. */
export function instagramUrl(settingValue?: string | null): string {
  return settingValue?.trim() || SOCIAL.instagram;
}

export function supportWhatsAppUrl(
  clinicWhatsapp?: string | null,
  message = "مرحبًا، عندي استفسار",
): string {
  return toWhatsAppLink(clinicWhatsapp, message);
}
